<template>
  <div class="container">
    <template v-if="showPage">
      <!-- 我的预约 -->
      <div class="my_appoint" @click="toMyAppoint">
        <div class="my_appoint_left">
          <img src="@/assets/images/icon_meeting_book.png" />
          <span>我的订单</span>
        </div>
        <div class="my_appoint_right">
          <span>查看</span>
          <img src="@/assets/images/icon_indicator_next.png" />
        </div>
      </div>
      <!-- 列表 -->
      <div class="mainList">
        <scroll
          :data="meetingRoomList"
          :allLoaded="noMess"
          @pulldown="loadData"
          @loadUp="loadup"
          v-if="meetingRoomList.length"
        >
          <div v-for="(item,index) in meetingRoomList" :key="index">
            <list-item :item="item" @viewBigPic="viewBigPic"></list-item>
          </div>
        </scroll>
        <div class="noMess" v-if="meetingRoomList.length <= 0 && loading">
          <no-message text="暂无数据"></no-message>
        </div>
      </div>
    </template>
        <!-- 查看大图 -->
    <fade-animation>
      <common-gallary
        :imgs="imgsArr"
        v-show="showGallary"
        @close="showGallary = false"
      ></common-gallary>
    </fade-animation>
  </div>
</template>

<script>
import ListItem from "./components/boardroomListItem.vue";
import Scroll from "../../../components/scroll";
import NoMessage from "../../../components/nomessage";
import util from "../../../utils/util";
import { mapState } from "vuex";
import CommonGallary from '../../../components/Gallary';
import FadeAnimation from '../../../components/FadeAnimation';
import * as api from "@/utils/api";
export default {
  name: "smartOfficeMeetingRoom",
  components: {
    ListItem,
    Scroll,
    NoMessage,
    CommonGallary,
    FadeAnimation
  },
  data() {
    return {
      showPage:false,
      meetingRoomList: [],
      marketData: [], //项目列表
      pageNo: 1,
      tabselected: -1, //选中哪一个tab，默认都不选中
      marketSelected: false,
      priceSelected: false,
      noMess: false, //判断是否加载最后
      prices: "", //选择的价格
      marketId: "",
      loading: false,
      showGallary:false,
      imgsArr:[]
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.getMeetingRoomList();
  },
  activated() {
    if(this.common.isChange){
      this.$store.commit('isChange', false);
      this.getMeetingRoomList();
    }
  },
  methods: {
    viewBigPic(val){
      this.imgsArr = [];
      this.imgsArr.push(val)
      this.showGallary = true;
    },
    // 上拉加载
    loadup() {
      if (this.noMess) {
        return;
      }
      this.pageNo++;
      this.getMeetingRoomList();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      this.getMeetingRoomList();
    },
    // 点击tab
    tabClick(index){
      let data = this.tabsData;
      data.forEach((item,i)=>{
        if(i==index){
          item.selected = !item.selected
        }else{
          item.selected = false
        }
      })
      this.tabsData = data;
      this.tabselected = index;
    },
    // 获取会议室列表数据
    getMeetingRoomList() {
      this.loading = false;
      this.noMore = false;
      util.showLoading();
      api.getMeetingRoomList({
        pageNo: this.pageNo,
        companyId: this.common.userTenantInfo.companyId,
        pageSize: 10,
        queryDate: util.formatTime(new Date(), 4)
      }).then(res => {
        console.log(res);
        this.showPage = true;
        if (res.res && res.res.code == 10000 && res.body) {
          let data = res.body.meetingRoomList || [];
          data.forEach(item => {
            let beginTimeIndex = Number(item.beginTime.split(":")[0])*2+Number(item.beginTime.split(":")[1]==30?1:0);
            let endTimeIndex = Number(item.endTime.split(":")[0])*2+Number(item.endTime.split(":")[1]==30?1:0);
            let newT = util.formatTime(new Date(),22);
            let newIndex = Number(newT.split(":")[0])*2+Number(newT.split(":")[1]>30?1:0);
            let status = item.meetingStatus;
            status.forEach((item,index)=>{
              if(index < beginTimeIndex || index > endTimeIndex){status[index] = 1;}
              if(newIndex == index){status[index+1] = 1}
            })
            if (item.meetingStatus) {
              item.amData = status.slice(1, 26);
              item.pmData = status.slice(25).concat([1,1]);
            }
          });
          if (data.length != 10) {
            this.noMess = true;
          }
          if (this.pageNo == 1) {
            this.meetingRoomList = res.body.meetingRoomList;
          } else {
            this.meetingRoomList = this.meetingRoomList.concat(
              res.body.meetingRoomList
            );
          }
        }
        util.hideLoading();
        this.loading = true;
      });
    },
    toMyAppoint(){
      this.$router.push("/smartOffice/meetingAppoint")
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container {
  background: @colore;
  height:100vh;
}
span,
img {
  display: block;
}
.noMess {
  margin-top: 200px;
}
.mainList {
  position:absolute;
  top:100px;left:0;right:0;bottom:0;
  box-sizing:border-box;
}
// 我的预订
.my_appoint{
  height:100px;
  padding:0 20px 0 28px;
  .flex();
  justify-content: space-between;
  align-items: center;
  background:#fff;
  .my_appoint_left{
    .flex();
    img{
      width:36px;
      height:36px;
      margin-right:14px;
    }
    span{
      font-size:32px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:44px;
    }
  }
  .my_appoint_right{
    .flex();
    flex:1;
    justify-content: flex-end;
    align-items:center;
    img{
      width:32px;
      height:32px;
      margin-left:4px;
    }
    span{
      font-size:28px;
      color:rgba(153,153,153,1);
    }
  }
}
/* tab */
.tabs_box {
  position: fixed;
  top: 0;
  left: 0;right:0;
  z-index: 33;
  height: 88px;
  padding:0 28px;
  box-sizing:border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: @colore;
}
.tabs_item {
  height: 88px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.tabs_item span {
  font-size: 32px;
  color: rgba(51, 51, 51, 1);
  margin-right: 8px;
  white-space: nowrap;
  max-width: 224px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tabs_item_selected span {
  // color: @color17;
}
.tabs_item img {
  width: 24px;
  height: 24px;
}
/* 筛选列表 */
.list_main {
  position: fixed;
  top:100px;
  left: 0;
  right: 0;
  z-index: 33;
  background: #fff;
}
.price_list {
  padding: 28px;
}
.price_list_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 0;
}
.price_list_item {
  position: relative;
  width: 158px;
  height: 68px;
  box-sizing: border-box;
  .border();
  text-align: center;
  line-height: 68px;
  border-radius: 8px;
  overflow: hidden;
}
.price_list_item span {
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
}
.price_list_item img {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 36px;
  height: 36px;
}
.price_btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 68px;
}
.price_btn span {
  width: 192px;
  height: 68px;
  box-sizing: border-box;
  text-align: center;
  line-height: 68px;
  margin-left: 20px;
  border-radius: 8px;
  .border();
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
}
.price_btn span.price_sure {
  border-color: @color17;
  background: @color17;
  color: #fff;
}
/* market_list */
.city_title {
  width: 710px;
  padding-left: 40px;
  height: 76px;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 76px;
  background: rgba(248, 248, 248, 1);
}
.market_item {
  padding: 28px 40px 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.market_item_last {
  padding-bottom: 40px;
}
.market_item span {
  font-size: 32px;
  color: rgba(51, 51, 51, 1);
}
.market_item img {
  width: 32px;
  height: 32px;
}
.market_item_select span {
  color: @color17;
}
.scroll_view {
  height: 604px;
}
/* market_list end*/

.filter_bg {
  position: fixed;
  top: 100px;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 22;
}
</style>